import { css  } from '@emotion/core'
import { mq } from '../../cssInJs'

export default {
  top: css(mq({
    //height: [44, null, 80],
    height: [80, null, 130],
    background: 'transparent',
    position: 'fixed',
    width: '100%',
    zIndex: '999',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.3s'
  })),
  topScrolled: css(mq({
    height: [44, null, 84],
    background: 'black',
  })),
  logo: css(mq({
  })),
  logoImg: css(mq({
    display: 'block',
    height: [48, null, 100],
  })),
  logoScrolled: css(mq({
img: css(mq({
      height: [34, null, 54],
      marginTop: ['0px', null, '0px']
    }))
  })),
}